import { render } from "./extendsComponent.vue?vue&type=template&id=dd2ecdfa&scoped=true"
import script from "./extendsComponent.vue?vue&type=script&lang=js"
export * from "./extendsComponent.vue?vue&type=script&lang=js"

import "./extendsComponent.vue?vue&type=style&index=0&id=dd2ecdfa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2ecdfa"]])

export default __exports__